import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BasmatiRiceImage from '../assets/banners/basmati.jpg';
import { FaGlobe, FaWeight, FaLeaf, FaWarehouse } from 'react-icons/fa';

const BasmatiRice = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Basmati Rice Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your Basmati Rice.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-50 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-yellow-800 mb-4">Premium Basmati Rice</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Naturally aged, long-grain Basmati rice with a rich aroma and delicate texture — perfect for biryanis, pulaos, and global cuisines.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={BasmatiRiceImage}
                        alt="Basmati Rice"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-yellow-800 mb-6">Why Choose Our Basmati Rice?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-700 mt-1" />100% pure, aged, long-grain Basmati</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-700 mt-1" />Extra-long slender grains with non-sticky texture</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-700 mt-1" />Rich aroma and fluffy post-cook expansion</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-700 mt-1" />Sourced from premium rice belts of India</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-700 mt-1" />Ideal for Biryani, Fried Rice, Pilaf, and Global Dishes</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-yellow-100 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-yellow-800 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-yellow-300 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-300">
                                    <th className="p-4 text-left bg-yellow-200">Grain Type</th>
                                    <td className="p-4">Long-Grain, Slender</td>
                                </tr>
                                <tr className="border-b border-yellow-300">
                                    <th className="p-4 bg-yellow-200">Aroma</th>
                                    <td className="p-4">Strong Natural Fragrance</td>
                                </tr>
                                <tr className="border-b border-yellow-300">
                                    <th className="p-4 bg-yellow-200">Cooking Ratio</th>
                                    <td className="p-4">1 cup rice : 1.5 cups water</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-200">Available Grades</th>
                                    <td className="p-4">1121 Steam, Sella, Raw, Golden</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-yellow-300 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-300">
                                    <th className="p-4 text-left bg-yellow-200">Packaging</th>
                                    <td className="p-4">5kg, 10kg, 25kg | PP Bags, Jute Bags, Vacuum Packs</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-200">Shelf Life</th>
                                    <td className="p-4">24 Months</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaGlobe className="text-4xl mx-auto text-yellow-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Export Quality</h4>
                </div>
                <div>
                    <FaWeight className="text-4xl mx-auto text-yellow-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Heavy, Mature Grains</h4>
                </div>
                <div>
                    <FaLeaf className="text-4xl mx-auto text-yellow-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Naturally Fragrant</h4>
                </div>
                <div>
                    <FaWarehouse className="text-4xl mx-auto text-yellow-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Bulk Supply Ready</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-yellow-200 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-yellow-900 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-yellow-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-yellow-700 hover:bg-yellow-800 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default BasmatiRice;
